(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jebla-coffee-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jebla-coffee-finder')) {
    customElements.define('jebla-coffee-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.results = this.querySelector('.jcf__results');
        this.grid = this.querySelector('.jcf__grid');
        this.messages = Object.fromEntries([...this.querySelectorAll('[data-message]')].map(el => [el.dataset.message, el.textContent]));
        this.cards = [...this.querySelector('template').content.querySelectorAll('article')].map(el => ({el, acidity:Number(el.dataset.acidity),bitterness:Number(el.dataset.bitterness),body:Number(el.dataset.body),flavors:JSON.parse(el.dataset.flavors),brewing:JSON.parse(el.dataset.brewing)})).filter(p => ['acidity','bitterness','body'].every(k => Number.isInteger(p[k]) && p[k]>=1 && p[k]<=10) && Array.isArray(p.flavors) && p.flavors.length && Array.isArray(p.brewing) && p.brewing.length);
        this.form.hidden = false;
        this.form.addEventListener('input', () => {this.results.hidden=true;});
        this.form.addEventListener('reset', () => {requestAnimationFrame(() => {this.results.hidden=true;this.grid.replaceChildren();});});
        this.form.addEventListener('submit', e => {e.preventDefault();this.recommend();});
        
      }
      level(value) { return value <= 3 ? 'low' : value <= 6 ? 'medium' : 'high'; }
      distance(value, level) {
        const [min,max]={low:[1,3],medium:[4,6],high:[7,10]}[level];
        return Math.max(min-value,0,value-max);
      }
      recommend() {
        const data=new FormData(this.form), flavors=data.getAll('flavor');
        const metrics=['acidity','bitterness','body'].filter(k=>data.get(k)!=='any');
        const preferences=metrics.length>0||flavors.length>0;
        const ranked=this.cards.map(p=>{
          const matches=flavors.filter(f=>p.flavors.includes(f));
          const distance=metrics.reduce((n,k)=>n+this.distance(p[k],data.get(k))*(k==='acidity'?3:1),0);
          const score=distance+(flavors.length?12*(1-matches.length/flavors.length):0);
          const exact=metrics.every(k=>this.level(p[k])===data.get(k))&&matches.length===flavors.length;
          return {...p,matches,score,exact};
        }).sort((a,b)=>a.score-b.score);
        this.grid.replaceChildren();
        this.querySelector('.jcf__status').textContent=!ranked.length?this.messages.empty:!preferences?this.messages.explore:!ranked[0].exact?this.messages.fallback:'';
        ranked.slice(0,3).forEach((p,i)=>{
          const card=p.el.cloneNode(true);
          card.querySelector('.jcf__badge').textContent=preferences&&i===0?this.messages.best:this.messages.alternative;
          card.querySelector('.jcf__reason').textContent=this.messages.acidity_label+': '+this.messages['acidity_'+this.level(p.acidity)];
          card.querySelector('.jcf__metrics').textContent=['bitterness','body'].map(k=>this.messages[k]+': '+this.messages[k+'_'+this.level(p[k])]).join(' · ');
          card.querySelector('.jcf__flavor-reason').textContent=flavors.length?(p.matches.length?this.messages.matching_notes+' '+p.matches.map(f=>this.messages[f]).join('، '):this.messages.different_notes):p.flavors.map(f=>this.messages[f]||f).join('، ');
          const add=card.querySelector('.jcf__add');
          add.addEventListener('click',async()=>{
            const label=add.textContent;add.disabled=true;add.textContent=this.messages.adding;
            const status=card.querySelector('.jcf__cart-status');status.textContent='';
            try {
              const response=await fetch(this.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:card.dataset.id,quantity:1}]})});
              if(!response.ok)throw new Error('cart');
              await response.json();
              status.textContent=this.messages.added;
              card.querySelector('.jcf__cart-link').hidden=false;
            }catch(e){status.textContent=this.messages.error;}
            finally{add.disabled=false;add.textContent=label;}
          });
          this.grid.append(card);
        });
        this.results.hidden=false;
        this.results.querySelector('h3').focus({preventScroll:true});
        this.results.scrollIntoView({behavior:'auto',block:'start'});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
